import type { SvgIconComponent } from "@mui/icons-material";
import BusinessIcon from "@mui/icons-material/BusinessOutlined";
import HomeIcon from "@mui/icons-material/HomeOutlined";
import Inventory2Icon from "@mui/icons-material/Inventory2Outlined";
import LayersIcon from "@mui/icons-material/LayersOutlined";
import MapIcon from "@mui/icons-material/MapOutlined";
import NotificationsIcon from "@mui/icons-material/NotificationsNoneOutlined";

import { ROUTES } from "src/routes/paths";

export interface NavItem {
	/** i18n key under `nav.` and the bottom-tab value. */
	key: "launchpad" | "explore" | "showcases" | "solutions" | "activity" | "companies";
	to: string;
	icon: SvgIconComponent;
	/** Only the exact path is active (the launchpad is "/"). */
	end?: boolean;
}

/** The Figma Desktop v3 primary nav. */
export const NAV_ITEMS: readonly NavItem[] = [
	{ key: "launchpad", to: ROUTES.home, icon: HomeIcon, end: true },
	{ key: "explore", to: ROUTES.explore, icon: MapIcon },
	{ key: "showcases", to: ROUTES.showcases, icon: Inventory2Icon },
	{ key: "solutions", to: ROUTES.solutions, icon: LayersIcon },
	{ key: "activity", to: ROUTES.activity, icon: NotificationsIcon }
];

/** Below the primary nav: the account hierarchy, which matters more to Digital Realty staff than to prospects. */
export const SECONDARY_NAV_ITEMS: readonly NavItem[] = [{ key: "companies", to: ROUTES.companies, icon: BusinessIcon }];

/**
 * Figma M04 "Tab bar": Home, Explore, Solutions (Advisor is added by the tab bar itself). Activity
 * lives behind the header's bell on phones.
 */
export const MOBILE_TAB_KEYS: readonly NavItem["key"][] = ["launchpad", "explore", "solutions"];

/** Which nav item a path belongs to (company pages belong to Companies, etc.). */
export const activeNavKey = (pathname: string): NavItem["key"] | undefined => {
	if (pathname === ROUTES.home) return "launchpad";
	if (pathname.startsWith(ROUTES.companies)) return "companies";
	if (pathname.startsWith(ROUTES.explore)) return "explore";
	if (pathname.startsWith(ROUTES.showcases)) return "showcases";
	if (pathname.startsWith(ROUTES.solutions)) return "solutions";
	if (pathname.startsWith(ROUTES.activity)) return "activity";
	return undefined;
};
